import React, { ReactNode } from 'react';
import { Box, Flex } from '@mantine/core';
import { useContainerQuery } from 'src/UI/app-container/ContainerBreakpoint';
import { Sidebar } from './sidebar/Sidebar';
import { SidebarItem } from './sidebar/types';

type PageWithSidebarProps = {
  links: SidebarItem[];
  activeUrl: string;
  children: ReactNode;
};

export default function PageWithSidebar({ links, activeUrl, children }: PageWithSidebarProps) {
  const cq = useContainerQuery();

  return (
    <Flex gap={cq({ base: 'md', lg: 'xl', xl: 'xxl' })} align="flex-start" wrap="nowrap">
      <Sidebar links={links} activeUrl={activeUrl} />
      <Box style={{ flex: 1, minWidth: 0 }}>{children}</Box>
    </Flex>
  );
}
